export enum OrderRepresentation {
  NotApplicable = 0,
  RepresentingSeller = 1,
  RepresentingBuyer = 2,
  RepresentingBoth = 3,
}
